<template>
  <div class="files-page">
    <banner title="资料下载" />
    <section class="files-panel">
      <el-tabs v-model="activeTab" @tab-click="loadFiles">
        <el-tab-pane label="产品手册" name="1">
          <div class="file-grid" v-if="files.length">
            <article class="file-card" v-for="file in files" :key="file.id">
              <div class="file-card-top">
                <div class="file-icon">
                  <i class="el-icon-document"></i>
                </div>
                <span class="file-type">{{ getFileExt(file) }}</span>
              </div>
              <div class="file-content">
                <h3>{{ file.title }}</h3>
                <p>{{ getFileDesc(file) }}</p>
              </div>
              <button
                class="download-button"
                type="button"
                :aria-label="`下载${file.title}`"
                @click="downloadFile(file)"
              >
                <i class="el-icon-download"></i>
                <span>下载</span>
              </button>
            </article>
          </div>
          <div class="empty-state" v-else>
            <i class="el-icon-folder-opened"></i>
            <p>暂无资料</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="技术手册" name="2">
          <div class="file-grid" v-if="files.length">
            <article class="file-card" v-for="file in files" :key="file.id">
              <div class="file-card-top">
                <div class="file-icon">
                  <i class="el-icon-document"></i>
                </div>
                <span class="file-type">{{ getFileExt(file) }}</span>
              </div>
              <div class="file-content">
                <h3>{{ file.title }}</h3>
                <p>{{ getFileDesc(file) }}</p>
              </div>
              <button
                class="download-button"
                type="button"
                :aria-label="`下载${file.title}`"
                @click="downloadFile(file)"
              >
                <i class="el-icon-download"></i>
                <span>下载</span>
              </button>
            </article>
          </div>
          <div class="empty-state" v-else>
            <i class="el-icon-folder-opened"></i>
            <p>暂无资料</p>
          </div>
        </el-tab-pane>
      </el-tabs>
    </section>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  components: {
    Banner
  },
  data() {
    return {
      activeTab: "1",
      files: []
    };
  },
  methods: {
    loadFiles() {
      this.$http
        .get(`filesDownloads/${this.activeTab}`)
        .then(response => {
          this.files = response.result || [];
        })
        .catch(() => {
          this.files = [];
        });
    },
    downloadFile(file) {
      window.open(this.imgserver + file.filePath);
    },
    getFileExt(file) {
      const source = file.filePath || file.title || "";
      const ext = source.split(".").pop();
      if (!ext || ext === source) return "FILE";
      return ext.toUpperCase();
    },
    getFileDesc(file) {
      return file.description || "资料文件";
    }
  },
  created() {
    this.loadFiles();
  }
};
</script>

<style lang="scss" scoped>
.files-page {
  min-height: 100%;
  background: #eef4f8;
}

.files-panel {
  width: min(1180px, 92%);
  margin: -34px auto 56px;
  padding: 28px 36px 42px;
  box-sizing: border-box;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 22px 58px rgba(18, 48, 78, 0.12);
  position: relative;
  z-index: 2;
}

.file-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 22px;
  padding-top: 22px;
}

.file-card {
  min-height: 222px;
  padding: 24px;
  box-sizing: border-box;
  border: 1px solid #dceaf5;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff, #fbfdff);
  box-shadow: 0 12px 28px rgba(20, 34, 53, 0.05);
  transition: transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease, background 0.25s ease;
}

.file-card::before {
  content: "";
  position: absolute;
  inset: 0 0 auto;
  height: 3px;
  background: linear-gradient(90deg, #156da8, #2cace2);
  opacity: 0;
  transition: opacity 0.25s ease;
}

.file-card:hover {
  transform: translateY(-4px);
  border-color: rgba(44, 172, 226, 0.58);
  background: #fff;
  box-shadow: 0 22px 44px rgba(20, 34, 53, 0.12);
}

.file-card:hover::before {
  opacity: 1;
}

.file-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.file-icon {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  background: linear-gradient(180deg, #e9f8ff, #dff3ff);
  color: #156da8;
  font-size: 23px;
}

.file-type {
  max-width: 120px;
  min-height: 28px;
  padding: 0 10px;
  border: 1px solid rgba(21, 109, 168, 0.16);
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f7fbfe;
  color: #075b94;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-content {
  min-width: 0;
  flex: 1;
}

.file-content h3 {
  min-height: 52px;
  margin-top: 18px;
  color: #142235;
  font-size: 19px;
  font-weight: 800;
  line-height: 1.38;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.file-content p {
  margin-top: 10px;
  color: #607286;
  font-size: 14px;
  line-height: 1.65;
  min-height: 46px;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.download-button {
  width: 100%;
  min-height: 42px;
  margin-top: 18px;
  padding: 0 16px;
  border: 1px solid rgba(44, 172, 226, 0.5);
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: #f7fbfe;
  color: #075b94;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: color 0.22s ease, background 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease;
}

.download-button:hover {
  border-color: #156da8;
  background: #156da8;
  color: #fff;
  box-shadow: 0 12px 24px rgba(21, 109, 168, 0.2);
}

.empty-state {
  min-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #7d8fa3;
}

.empty-state i {
  font-size: 42px;
  color: #b7c7d8;
}

.empty-state p {
  margin-top: 12px;
  font-size: 16px;
}

:deep(.el-tabs__nav-wrap::after) {
  height: 1px;
  background: #e3edf5;
}

:deep(.el-tabs__item) {
  color: #31465d;
  font-weight: 600;
}

:deep(.el-tabs__item.is-active) {
  color: #075b94;
}

:deep(.el-tabs__active-bar) {
  height: 3px;
  border-radius: 999px;
  background: linear-gradient(90deg, #156da8, #2cace2);
}

@media (max-width: 680px) {
  .files-panel {
    width: 94%;
    padding: 22px 16px 34px;
  }

  .file-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .file-card {
    min-height: auto;
    padding: 20px;
  }

  .file-content h3,
  .file-content p {
    min-height: auto;
  }
}
</style>
